// extracted by mini-css-extract-plugin
export var tagHeader = "tag-module--tagHeader--1Ik6G";
export var taglist = "tag-module--taglist--3gGSd";
export var allTag = "tag-module--allTag--32lZH";
export var small = "tag-module--small--2Q6Vl";
export var tagLink = "tag-module--tagLink--3-3D6";